var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHouseBadge = function SvgHouseBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDAC8",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#1F1F1F",
    cx: 12,
    cy: 12,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.585 9.522l-4.001 3.295v3.557c0 .192.155.347.347.347l2.432-.006a.347.347 0 00.345-.347V14.29c0-.192.156-.348.348-.348h1.389c.191 0 .347.156.347.348v2.076c0 .192.155.347.347.347l2.431.007a.347.347 0 00.347-.347v-3.56l-4-3.292a.263.263 0 00-.332 0zm6.32 2.24l-1.814-1.496V7.26a.26.26 0 00-.26-.26h-1.216a.26.26 0 00-.26.26v1.576l-1.943-1.598a1.04 1.04 0 00-1.324 0l-5.493 4.524a.26.26 0 00-.035.366l.553.673a.26.26 0 00.367.036l5.105-4.205a.263.263 0 01.332 0l5.105 4.205a.26.26 0 00.367-.035l.553-.673a.26.26 0 00-.037-.367z",
    fill: "#1F1F1F",
    fillRule: "nonzero"
  }))));
};

export default SvgHouseBadge;